module.exports = __webpack_public_path__ + "static/media/blank_canvas.b0b283cb.svg";